import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import "./SCADAWTP.js";
import "./SCADAWTPDetails.css";

export default function SCADAWTPDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { intakeId } = useParams();

  const rowData = location.state?.rowData;

  const tableRef = useRef();


  

//   const [fromDate, setFromDate] = useState("2026-08-01");
//   const [toDate, setToDate] = useState("2026-08-14");

// const [searchFromDate, setSearchFromDate] = useState("2026-08-01");
// const [searchToDate, setSearchToDate] = useState("2026-08-14");


const today = new Date();
const lastDate = new Date(today);
lastDate.setDate(today.getDate() - 5);

const formatDateNew = (date) => {
  return date.toISOString().split("T")[0];
};

const [fromDate, setFromDate] = useState(formatDateNew(lastDate));
const [toDate, setToDate] = useState(formatDateNew(today));

const [searchFromDate, setSearchFromDate] = useState(formatDateNew(lastDate));
const [searchToDate, setSearchToDate] = useState(formatDateNew(today));

const [scada, setScada] = useState([]);
const [loading, setLoading] = useState(false);
const [error, setError] = useState("");

  // const fromDate = "2026-08-01";
  // const toDate = "2026-08-14";

  /*
   * =========================================================
   * BACK BUTTON
   * =========================================================
   */
  const handleBackToClick = () => {
    navigate("/SCADAWTPDashboard", {
      state: {
        rowData: rowData,
      },
    });
  };

  /*
   * =========================================================
   * FORMAT DATE
   * =========================================================
   */
const formatDate = (date) => {
  const year = date.getFullYear();

  const month = String(
    date.getMonth() + 1
  ).padStart(2, "0");

  const day = String(
    date.getDate()
  ).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


  /*
   * =========================================================
   * LOAD COMPLETE SCADA DATA
   * =========================================================
   */


useEffect(() => {
  if (!intakeId || !searchFromDate || !searchToDate) {
    return;
  }

  loadData();
}, [intakeId, searchFromDate, searchToDate]);



const loadData = async () => {
  try {
    setLoading(true);
    setError("");
    setScada([]);

    const start = new Date(searchFromDate);
    const end = new Date(searchToDate);

    const allData = [];

    let currentStart = new Date(start);

    /*
     * ============================================
     * FETCH DATA IN 7-DAY BLOCKS
     * ============================================
     */

    while (currentStart <= end) {

      const currentEnd = new Date(currentStart);

      /*


       * 7 days INCLUDING start date
       * Example:
       * 01 -> 07
       * 08 -> 14
       */
      currentEnd.setDate(
        currentEnd.getDate() + 7
      );

      /*
       * Don't go beyond selected To Date
       */
      if (currentEnd > end) {
        currentEnd.setTime(
          end.getTime()
        );
      }

      const rangeFromDate =
        formatDate(currentStart);

      const rangeToDate =
        formatDate(currentEnd);

      console.log(
        "================================="
      );

      console.log(
        "Fetching SCADA:",
        rangeFromDate,
        "to",
        rangeToDate
      );

      /*
       * ============================================
       * API
       * ============================================
       */

      const response = await fetch(
        "https://urbangis.mp.gov.in/api/Station_Data/Get_Intake_Wtp_Oht_Data_in_Date_Range",
        {
          method: "POST",

          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            intakeId: intakeId,
            fromDate: rangeFromDate,
            toDate: rangeToDate,
          }),
        }
      );
 // alert(response);

      if (!response.ok) {
       // alert(response.status);
        throw new Error(
          `API Error ${response.status}`
        );
      }

      const result =
        await response.json();

      console.log(
        `API Result ${rangeFromDate} - ${rangeToDate}:`,
        result
      );

      /*
       * ============================================
       * ADD DATA
       * ============================================
       */

      if (
        result?.data &&
        Array.isArray(result.data)
      ) {
        allData.push(
          ...result.data
        );
      }

      /*
       * ============================================
       * MOVE TO NEXT 7 DAYS
       * ============================================
       */

      currentStart.setDate(
        currentStart.getDate() + 7
      );
    }

    /*
     * ============================================
     * SORT BY DATE
     * ============================================
     */

    allData.sort((a, b) => {

      const dateA = new Date(
        a?.intake?.recordDateTime || 0
      );

      const dateB = new Date(
        b?.intake?.recordDateTime || 0
      );

      return dateA - dateB;
    });

    /*
     * ============================================
     * REMOVE DUPLICATES
     * ============================================
     */

    const uniqueData = [];

    const seen = new Set();

    allData.forEach((item) => {

      const key =
        item?.intake?.recordDateTime ||
        JSON.stringify(item);

      if (!seen.has(key)) {

        seen.add(key);

        uniqueData.push(item);
      }
    });

    console.log(
      "================================="
    );

    console.log(
      "COMPLETE SCADA REPORT:",
      uniqueData
    );

    console.log(
      "TOTAL RECORDS:",
      uniqueData.length
    );

    /*
     * ============================================
     * SET DATA
     * ============================================
     */

    setScada(uniqueData);

  } catch (err) {

    console.error(
      "SCADA API Error:",
      err
    );

    setError(
      "Unable to load SCADA report."
    );

  } finally {

    setLoading(false);
  }
};

  /*
   * =========================================================
   * LOADING
   * =========================================================
   */
  if (loading) {
    return (
      <div className="loading">
        Loading SCADA Report...
          <button
    onClick={handleBackToClick}
    style={{
      height: "38px",
      border: "none",
      borderRadius: "6px",
      padding: "0 14px",
      color: "#fff",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      background:
        "linear-gradient(135deg,#24424f,#34476c)",
      boxShadow: "0 2px 5px rgba(14, 137, 14, 0.15)",
    }}
  >
    ← Home
  </button>
        
        </div>
    );
  }

  /*
   * =========================================================
   * ERROR
   * =========================================================
   */
  if (error) {
    return (
      <div className="loading">
        {error}
            <button
    onClick={handleBackToClick}
    style={{
      height: "38px",
      border: "none",
      borderRadius: "6px",
      padding: "0 14px",
      color: "#fff",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      background:
        "linear-gradient(135deg,#24424f,#34476c)",
      boxShadow: "0 2px 5px rgba(14, 137, 14, 0.15)",
    }}
  >
    ← Home
  </button>
      </div>
    );
  }

  /*
   * =========================================================
   * NO DATA
   * =========================================================
   */
  if (!scada.length) {
    return (
      <div className="loading">
        No SCADA data available.
         <button
    onClick={handleBackToClick}
    style={{
      height: "38px",
      border: "none",
      borderRadius: "6px",
      padding: "0 14px",
      color: "#fff",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      background:
        "linear-gradient(135deg,#24424f,#34476c)",
      boxShadow: "0 2px 5px rgba(14, 137, 14, 0.15)",
    }}
  >
    ← Home
  </button>
      </div>
    );
  }

  /*
   * =========================================================
   * FIRST RECORD
   * =========================================================
   *
   * Used for title and column structure.
   */
  const firstItem =
    scada[0] || {};

  const firstIntake =
    firstItem.intake || {};

  /*
   * =========================================================
   * FIND MAXIMUM PUMP/OHT STRUCTURE
   * =========================================================
   *
   * Important because records from different dates
   * may have different arrays.
   */

  let maxIntakePumps = 0;
  let maxWtpPumps = 0;
  let maxOhts = 0;

  scada.forEach((item) => {
    const intakePumps =
      item.intakePumps || [];

    const wtpUnit =
      item.wtpUnits?.[0] || {};

    const wtpPumps =
      wtpUnit.pumps || [];

    const ohts =
      wtpUnit.ohts || [];

    maxIntakePumps =
      Math.max(
        maxIntakePumps,
        intakePumps.length
      );

    maxWtpPumps =
      Math.max(
        maxWtpPumps,
        wtpPumps.length
      );

    maxOhts =
      Math.max(
        maxOhts,
        ohts.length
      );
  });

  /*
   * =========================================================
   * COLUMN COUNTS
   * =========================================================
   */

  const intakeColCount =
    1 + // Intake Level
    1 + // Outlet Flow
    2 + // Power + PF
    maxIntakePumps * 2 +
    1; // Header

  const wtpColCount =
    1 + // Inlet
    1 + // Outlet
    1 + // Backwash
    1 + // CWR
    2 + // Raw Water
    3 + // Clear Water
    maxWtpPumps * 2 +
    1; // Header

  const ohtColCount =
    maxOhts * 4;

  /*
   * =========================================================
   * EXCEL DOWNLOAD
   * =========================================================
   */

  const downloadExcel = () => {
    if (!tableRef.current) {
      return;
    }

    const table =
      tableRef.current.querySelector(
        "table"
      );

    if (!table) {
      return;
    }

    const workbook =
      XLSX.utils.table_to_book(
        table,
        {
          sheet: "SCADA Report",
        }
      );

    const excelBuffer =
      XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

    const file = new Blob(
      [excelBuffer],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

    saveAs(
      file,
      `${
        firstIntake?.intakeWellName ||
        "SCADA_Report"
      }_${fromDate}_to_${toDate}.xlsx`
    );
  };

  /*
   * =========================================================
   * DATE DISPLAY
   * =========================================================
   */

  const displayDate = (date) => {
    if (!date) {
      return "-";
    }

    const parsedDate =
      new Date(date);

    if (
      Number.isNaN(
        parsedDate.getTime()
      )
    ) {
      return date;
    }

    return parsedDate.toLocaleDateString(
      "en-IN"
    );
  };

  /*
   * =========================================================
   * RENDER
   * =========================================================
   */

  return (
    <div>

      {/* =================================================
          BUTTONS
      ================================================= */}

      {/* =================================================
          REPORT
      ================================================= */}

      <div
        className="table-wrapper"
        ref={tableRef}
      >

        {/* =================================================
            HEADER TITLE
        ================================================= */}

      <div
  style={{
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "12px 15px",
    marginBottom: "15px",
    boxSizing: "border-box",
    background: "#ffffff",
    border: "1px solid #dce7e8",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    flexWrap: "nowrap",
  }}
>
  {/* SCHEME NAME */}
  <div
    style={{
      minWidth: "180px",
      flex: "1",
      textAlign: "left",
    }}
  >
    <div
      style={{
        color: "#123b59",
        fontSize: "20px",
        fontWeight: "700",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {firstIntake?.schemeName || "SCADA WTP Report"}
      <br/>
     <p style={{ color: "#03514c",}}>  Intake ID: {firstIntake?.intakeId || intakeId} </p>
    </div>

 </div>


  {/* REPORT PERIOD */}
  <div
    style={{
      minWidth: "190px",
      textAlign: "center",
      whiteSpace: "nowrap",
    }}
  >
    <div
      style={{
        color: "#03514c",
        fontSize: "12px",
        fontWeight: "600",
      }}
    >
      Report Period
    </div>

    <div
      style={{
      color: "#03514c",
        fontSize: "13px",
        fontWeight: "700",
      }}
    >
      {displayDate(fromDate)} - {displayDate(toDate)}
    </div>
  </div>

  {/* FROM DATE */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      minWidth: "145px",
    }}
  >
    <label
      style={{
        color: "#27495d",
        fontSize: "11px",
        fontWeight: "700",
        marginBottom: "3px",
      }}
    >
      From Date
    </label>

    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      style={{
        width: "145px",
        height: "38px",
        boxSizing: "border-box",
        padding: "0 8px",
        border: "1px solid #b9cccc",
        borderRadius: "6px",
        background: "#ffffff",
        color: "#173e5c",
        fontSize: "13px",
        fontWeight: "500",
        outline: "none",
        cursor: "pointer",
      }}
    />
  </div>

  {/* TO DATE */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      minWidth: "145px",
    }}
  >
    <label
      style={{
        color: "#27495d",
        fontSize: "11px",
        fontWeight: "700",
        marginBottom: "3px",
      }}
    >
      To Date
    </label>

    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      style={{
        width: "145px",
        height: "38px",
        boxSizing: "border-box",
        padding: "0 8px",
        border: "1px solid #b9cccc",
        borderRadius: "6px",
        background: "#ffffff",
        color: "#173e5c",
        fontSize: "13px",
        fontWeight: "500",
        outline: "none",
        cursor: "pointer",
      }}
    />
  </div>

  {/* GENERATE REPORT */}
<button
  onClick={() => {

    if (!fromDate || !toDate) {
      alert(
        "Please select From Date and To Date"
      );
      return;
    }

    if (fromDate > toDate) {
      alert(
        "From Date cannot be greater than To Date"
      );
      return;
    }

    /*
     * These values trigger useEffect
     * and therefore loadData()
     */

    setSearchFromDate(fromDate);
    setSearchToDate(toDate);
  }}
  style={{
    height: "38px",
    border: "none",
    borderRadius: "6px",
    padding: "0 14px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "600",
    whiteSpace: "nowrap",
    background:
      "linear-gradient(135deg,#006f6b,#008f87)",
    boxShadow:
      "0 2px 5px rgba(0,0,0,0.15)",
  }}
>
  🔍 Generate
</button>

  {/* EXCEL */}
  <button
    onClick={downloadExcel}
    style={{
      height: "38px",
      border: "none",
      borderRadius: "6px",
      padding: "0 14px",
      color: "#fff",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      background:
        "linear-gradient(135deg,#087443,#07966a)",
      boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
    }}
  >
    📥 Excel
  </button>
  {/* BACK */}
  <button
    onClick={handleBackToClick}
    style={{
      height: "38px",
      border: "none",
      borderRadius: "6px",
      padding: "0 14px",
      color: "#fff",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      background:
        "linear-gradient(135deg,#24324f,#34476c)",
      boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
    }}
  >
    ← Back
  </button>

</div>



        {/* =================================================
            TABLE
        ================================================= */}
<div
  className="table-wrapper"
  ref={tableRef}
>
   <table className="scada-table">

          <thead>

            {/* =============================================
                LEVEL 1
            ============================================= */}

            <tr>

              <th
                rowSpan="3"
                className="date-col"
              >
                Date
              </th>

              <th
                colSpan={
                  intakeColCount
                }
                className="head-green"
              >
                Intake Well MLD
              </th>

              <th
                colSpan={
                  wtpColCount
                }
                className="head-orange"
              >
                WTP
              </th>

              {ohtColCount >
                0 && (
                <th
                  colSpan={
                    ohtColCount
                  }
                  className="head-blue"
                >
                  OHT Details
                </th>
              )}

            </tr>


            {/* =============================================
                LEVEL 2
            ============================================= */}

            <tr>

              {/* INTAKE */}

              <th rowSpan="2">
                Intake Level
              </th>

              <th rowSpan="2">
                Outlet Flow
              </th>

              <th colSpan="2">
                Electrical
              </th>

              <th
                colSpan={
                  maxIntakePumps *
                    2 +
                    1
                }
              >
                Pressure
              </th>


              {/* WTP */}

              <th rowSpan="2">
                Inlet
              </th>

              <th rowSpan="2">
                Outlet
              </th>

              <th rowSpan="2">
                Backwash
              </th>

              <th rowSpan="2">
                CWR
              </th>

              <th colSpan="2">
                Raw Water
              </th>

              <th colSpan="3">
                Clear Water
              </th>

              <th
                colSpan={
                  maxWtpPumps *
                    2 +
                    1
                }
              >
                Pressure
              </th>


              {/* OHT */}

              {Array.from({
                length: maxOhts,
              }).map(
                (_, i) => {

                  /*
                   * Find OHT name from
                   * first record which
                   * contains this index.
                   */

                  let ohtName =
                    `OHT ${
                      i + 1
                    }`;

                  for (
                    const item of scada
                  ) {
                    const oht =
                      item
                        ?.wtpUnits?.[0]
                        ?.ohts?.[i];

                    if (
                      oht?.ohT_Name
                    ) {
                      ohtName =
                        oht.ohT_Name;
                      break;
                    }
                  }

                  return (
                    <th
                      key={i}
                      colSpan="4"
                    >
                      {ohtName}
                    </th>
                  );
                }
              )}

            </tr>


            {/* =============================================
                LEVEL 3
            ============================================= */}

            <tr>

              {/* INTAKE ELECTRICAL */}

              <th>
                Power
              </th>

              <th>
                PF
              </th>


              {/* INTAKE PUMPS */}

              {Array.from({
                length:
                  maxIntakePumps,
              }).map(
                (_, i) => (
                  <React.Fragment
                    key={i}
                  >
                    <th>
                      Rated P
                      {i +
                        1}
                    </th>

                    <th>
                      Actual P
                      {i +
                        1}
                    </th>
                  </React.Fragment>
                )
              )}

              <th>
                Header
              </th>


              {/* WTP RAW */}

              <th>
                PH
              </th>

              <th>
                Turbidity
              </th>


              {/* WTP CLEAR */}

              <th>
                PH
              </th>

              <th>
                Chlorine
              </th>

              <th>
                Turbidity
              </th>


              {/* WTP PUMPS */}

              {Array.from({
                length:
                  maxWtpPumps,
              }).map(
                (_, i) => (
                  <React.Fragment
                    key={i}
                  >
                    <th>
                      Rated P
                      {i +
                        1}
                    </th>

                    <th>
                      Actual P
                      {i +
                        1}
                    </th>
                  </React.Fragment>
                )
              )}

              <th>
                Header
              </th>


              {/* OHT */}

              {Array.from({
                length: maxOhts,
              }).map(
                (_, i) => (
                  <React.Fragment
                    key={i}
                  >
                    <th>
                      Flow
                    </th>

                    <th>
                      Level
                    </th>

                    <th>
                      Cl
                    </th>

                    <th>
                      Pressure
                    </th>
                  </React.Fragment>
                )
              )}

            </tr>

          </thead>


          {/* =================================================
              DATA
          ================================================= */}

          <tbody>

            {scada.map(
              (item, index) => {

                const intake =
                  item.intake ||
                  {};

                const intakePumps =
                  item.intakePumps ||
                  [];

                const wtpUnit =
                  item
                    .wtpUnits?.[0] ||
                  {};

                const wtp =
                  wtpUnit.wtp ||
                  {};

                const wtpPumps =
                  wtpUnit.pumps ||
                  [];

                const ohts =
                  wtpUnit.ohts ||
                  [];


                return (
                  <tr
                    key={
                      index
                    }
                  >

                    {/* DATE */}

                    <td>
                      {displayDate(
                        intake.recordDateTime
                      )}
                    </td>


                    {/* =================================
                        INTAKE
                    ================================= */}

                    <td>
                      {intake
                        .intakeWellLevel ??
                        "-"}
                    </td>

                    <td>
                      {intake
                        .outletFlow ??
                        "-"}
                    </td>

                    <td>
                      {intake
                        .power_consumption_w ??
                        "-"}
                    </td>

                    <td>
                      {intake
                        .power_factor ??
                        "-"}
                    </td>


                    {/* INTAKE PUMPS */}

                    {Array.from({
                      length:
                        maxIntakePumps,
                    }).map(
                      (_, i) => {

                        const pump =
                          intakePumps[
                            i
                          ];

                        return (
                          <React.Fragment
                            key={i}
                          >

                            <td>
                              {pump
                                ?.ratedPressure ??
                                "-"}
                            </td>

                            <td>
                              {pump
                                ?.actualPressure ??
                                "-"}
                            </td>

                          </React.Fragment>
                        );
                      }
                    )}


                    <td>
                      {intake
                        .headerActualPressure ??
                        "-"}
                    </td>


                    {/* =================================
                        WTP
                    ================================= */}

                    <td>
                      {wtp
                        .inletFlow_mld ??
                        "-"}
                    </td>

                    <td>
                      {wtp
                        .outletFlow_mld ??
                        "-"}
                    </td>

                    <td>
                      {wtp
                        .backwashLevel ??
                        "-"}
                    </td>

                    <td>
                      {wtp
                        .cwrLevel ??
                        "-"}
                    </td>


                    {/* RAW WATER */}

                    <td>
                      {wtp
                        .rawPh ??
                        "-"}
                    </td>

                    <td>
                      {wtp
                        .rawTurbidity ??
                        "-"}
                    </td>


                    {/* CLEAR WATER */}

                    <td>
                      {wtp
                        .treatedPh ??
                        "-"}
                    </td>

                    <td>
                      {wtp
                        .chlorine ??
                        "-"}
                    </td>

                    <td>
                      {wtp
                        .treatedTurbidity ??
                        "-"}
                    </td>


                    {/* WTP PUMPS */}

                    {Array.from({
                      length:
                        maxWtpPumps,
                    }).map(
                      (_, i) => {

                        const pump =
                          wtpPumps[
                            i
                          ];

                        return (
                          <React.Fragment
                            key={i}
                          >

                            <td>
                              {pump
                                ?.ratedPressure ??
                                "-"}
                            </td>

                            <td>
                              {pump
                                ?.actualPressure ??
                                "-"}
                            </td>

                          </React.Fragment>
                        );
                      }
                    )}


                    <td>
                      {wtp
                        .headerActualPressure ??
                        "-"}
                    </td>


                    {/* =================================
                        OHT
                    ================================= */}

                    {Array.from({
                      length:
                        maxOhts,
                    }).map(
                      (_, i) => {

                        const oht =
                          ohts[i];

                        return (
                          <React.Fragment
                            key={i}
                          >

                            <td>
                              {oht
                                ?.inletFlow_mld ??
                                "-"}
                            </td>

                            <td>
                              {oht
                                ?.waterLevel_mld ??
                                "-"}
                            </td>

                            <td>
                              {oht
                                ?.residualChlorine ??
                                "-"}
                            </td>

                            <td>
                              {oht
                                ?.inletPressure ??
                                "-"}
                            </td>

                          </React.Fragment>
                        );
                      }
                    )}

                  </tr>
                );
              }
            )}

          </tbody>

        </table>
  
  </div>
       

      </div>

    </div>
  );
}
